import { Task } from 'make-traffic-integration-core';
import { useDispatch, useSelector } from 'react-redux';
import { useMakeTrafficManager as useSharedMakeTrafficManager } from '@make-software/tg-mini-app-ui';

import {
  useMe,
  fetchTasks,
  selectTask,
  selectTasks,
  selectSelectedTask,
  AppDispatch
} from '@/shared';

/**
 * Hook to access task manager data and actions.
 * Does NOT initialize the task manager - use useInitializeTaskManager for that.
 */
export const useMakeTrafficManager = () => {
  const me = useMe();
  const dispatch = useDispatch<AppDispatch>();
  const tasks = useSelector(selectTasks);
  const selectedTask = useSelector(selectSelectedTask);

  return useSharedMakeTrafficManager({
    userID: me.data?.user?.auth_user_id ?? undefined,
    authProvider: me.data?.user?.auth_provider ?? undefined,
    tasks,
    selectedTask,
    onSelectTask: (task: Task | null) => {
      dispatch(selectTask(task));
    },
    onRefreshTasks: () => {
      if (!me.data?.user) return;
      dispatch(
        fetchTasks({
          userID: me.data.user.auth_user_id || '',
          authProvider: me.data.user.auth_provider || ''
        })
      );
    }
  });
};
